import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import founderAmandeep from '../assets/about/founder-amandeep.jpg';
import founderGurpreet from '../assets/about/founder-gurpreet.jpg';

const OurStorySection: React.FC = () => {
  const navigate = useNavigate();

  return (
    <section className="bg-white py-16 lg:py-20">
      <div className="max-w-container-lg mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="font-manrope text-body-small text-brand-yellow mb-4"
          >
            Our Story
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="font-opensans text-display-xl text-text-primary font-bold"
          >
            Built on Heritage, Powered by Innovation
          </motion.h2>
        </div>

        {/* Content Container */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="bg-white rounded-2xl overflow-hidden relative"
          style={{ minHeight: '540px' }}
        >
          <div className="grid lg:grid-cols-3 gap-8 p-8 lg:p-12">
            {/* Left Founder Image */}
            <div className="flex flex-col items-center">
              <div className="relative w-full rounded-xl overflow-hidden mb-4" style={{ minHeight: '254px' }}>
                <img 
                  src={founderAmandeep} 
                  alt="Amandeep Singh Nanda"
                  className="w-full h-full object-contain"
                  style={{ objectPosition: 'center top' }}
                />
              </div>
              <p className="font-manrope text-center text-text-light"
                style={{
                  fontSize: '18px',
                  lineHeight: '28px',
                }}
              >
                Amandeep Singh Nanda
              </p>
            </div>

            {/* Center Content */}
            <div className="flex flex-col items-center justify-center text-center space-y-6">
              {/* Text Content */}
              <div className="font-manrope text-text-primary space-y-4 max-w-[470px]"
                style={{
                  fontSize: '20px',
                  lineHeight: '30px',
                }}
              >
                <p>
                  Master Ji is more than just software; it's the vision of two brothers.
                </p>
                <p>
                  Growing up between the time-honored garment industry of Ludhiana, India, and the cutting-edge AI/data tech world of the USA, they identified a critical challenge: the bespoke craft was lacking digital tools.
                </p>
                <p>
                  We combined that deep industry knowledge with modern technology to create Master Ji—a secure, efficient platform dedicated to preserving the artistry of tailoring while enabling creators to manage, scale, and thrive in the digital age.
                </p>
              </div>

              {/* CTA Button */}
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={() => navigate('/about')}
                className="bg-brand-blue text-brand-cream font-manrope px-8 py-3 rounded-3xl hover:bg-brand-blue/90 transition-all duration-300 mt-4"
                style={{ 
                  minWidth: '277px', 
                  height: '52px',
                  fontSize: '18px',
                  lineHeight: '28px',
                }}
              >
                Read our Full Mission & Story
              </motion.button>
            </div>

            {/* Right Founder Image */}
            <div className="flex flex-col items-center">
              <div className="relative w-full rounded-xl overflow-hidden mb-4" style={{ minHeight: '277px' }}>
                <img 
                  src={founderGurpreet} 
                  alt="Gurpreet Singh Nanda PhD"
                  className="w-full h-full object-contain"
                  style={{ objectPosition: 'center top' }}
                />
              </div>
              <p className="font-manrope text-center text-text-light"
                style={{
                  fontSize: '18px',
                  lineHeight: '28px',
                }}
              >
                Gurpreet Singh Nanda PhD
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default OurStorySection;

